import axios from 'axios';
import { showMessage } from '@/utils/toast';
import { getApiUrl, getUrlParam } from '@/utils';

const mockUrl = 'http://localhost:3721';

const baseApiUrl = getApiUrl();

const http = axios.create({
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
  },
});

const token = getUrlParam('token');

http.interceptors.request.use((config, baseURL = baseApiUrl) => {
  const headerParams = {
    'X-Auth': token,
    'x-version': '3.4.8',
    Referer: location.href.split('#')[0],
  };
  /* is mock */
  if (config?.isMock) baseURL = mockUrl;

  return {
    ...config,
    baseURL,
    headers: {
      ...config.headers,
      ...headerParams,
    },
  };
});

http.interceptors.response.use((res) => {
  if (res && res.data) {
    return res.data;
  } else {
    showMessage(res?.data?.message || '网络异常');
  }
});

export default http;
